<template>
  <div
    :id="member.id"
    data-testid="staff-card"
    class="contact-box"
    :style="styleColors"
  >
    <div class="staff-avatar">
      <img
        class="staff-image"
        :src="member.avatar"
        alt=""
      />
    </div>
    <div class="staff-info">
      <div class="name">
        {{ member.full_name }}
      </div>
      <div class="title">
        {{ member.title }}
      </div>
      <div class="department">
        {{ member.department }}
      </div>
      <div class="phone">
        {{ member.phone_number }}
      </div>
      <div
        v-if="member.email"
        class="email"
        data-testid="staff-email"
      >
        <div v-if="email === 'display_form_emails'">
          <button
            class="contact-button"
            @click="$emit('openContactModal', member)"
          >
            <span
              class="btn__content"
              tabindex="-1"
              >{{ $t('pages.staff.sendMessage') }}
            </span>
            <span class="sr-only">{{ $t('pages.staff.emailRecipient') }} {{ member.full_name }}</span>
          </button>
        </div>
        <div v-else-if="email === 'display_emails'">
          <a
            class="contact-button"
            :aria-label="$t('pages.staff.sendMessageToWithEmail', { person: member.full_name, email: member.email })"
            :href="`mailto:${member.email}`"
            >{{ member.email }}
          </a>
        </div>
      </div>
      <a
        v-if="member.class_link_url"
        data-testid="class-link"
        class="class-link"
        :href="member.class_link_url"
      >
        <span
          class="btn__content"
          tabindex="-1"
        >
          {{ member.class_link_name ? member.class_link_name : member.class_link_url }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaffCard',
  props: {
    member: {
      type: Object,
      default: null,
    },
    styleColors: {
      type: Object,
      default: null,
    },
    email: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.contact-box {
  display: flex;
  width: 50%;
  float: left;
  box-sizing: border-box;
  padding: 10px;
  @media screen and (max-width: 1000px) {
    width: 100%;
    border-bottom: 1px solid #ddd;
  }
  &:nth-of-type(2n + 1) {
    padding-left: 0;
    border-right: 1px solid #ddd;
    @media screen and (max-width: 1000px) {
      border-right: none;
    }
  }
  &:nth-of-type(2n) {
    padding-left: 25px;
    @media screen and (max-width: 1000px) {
      padding-left: 0;
    }
  }
  .staff-avatar {
    .staff-image {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    margin-right: 30px;
  }
  .staff-info {
    padding-top: 3px;
    .name {
      color: var(--primary-color);
    }
    .email a {
      color: var(--links-color);
    }
  }
  .name,
  .title,
  .department,
  .phone,
  .email,
  .class-link {
    line-height: 22px;
    word-break: break-word;
  }
  .name {
    font-size: 18px;
    text-transform: uppercase;
  }
  .title {
    color: #717171;
  }
  .department,
  .phone,
  .email,
  .class-link {
    font-size: 14px;
    color: #717171;
    margin: 2px 0;
  }

  .class-link {
    > .btn__content {
      outline: none;
    }
    & :deep(> *) {
      color: var(--links-color);
    }
    &:focus > .btn__content {
      outline: 1px dotted #212121;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

  .email {
    .contact-button {
      color: var(--links-color);
      text-decoration: none;
      cursor: pointer;
      background: none;
      border: none;
      text-align: left;
      padding: 0;
      font-size: 14px;
      margin: 0;
      &:hover {
        text-decoration: underline;
      }
      > .btn__content {
        outline: none;
      }
      &:focus > .btn__content {
        outline: 1px dotted #212121;
        outline: 5px auto -webkit-focus-ring-color;
      }
    }
  }
}
</style>
